export default {
  title: 'Deliverect',
  form: {
    channel_link_id: {
      label: 'Channel Link ID: ',
    },
    store_id: {
      label: 'External location id: ',
    },
    store_provisioning_url: {
      label: 'Store provisioning URL: ',
    },
  },
  buttons: {
    save: 'Speichern',
  },
  toasts: {
    error: 'Änderungen konnten nicht gespeichert werden',
    success: 'Änderungen wurden gespeichert',
  },
  instructions: {
    title: 'Einrichtungsanleitung:',
    step_1:
      'Öffnen Sie in Deliverect die Seite <Link>„Locations“</Link>, klappen Sie den passenden Standort auf und klicken Sie auf die Schaltfläche „+ Channel link“.',
    step_2:
      'Füllen Sie die erforderlichen Angaben aus. Wählen Sie im Schritt „Select your online delivery platform“ „Food Amigos“ aus.',
    step_3:
      'Schließen Sie alle Schritte ab. Klicken Sie anschließend auf der Seite „Locations“ beim Kanal „Food Amigos“ auf „Edit“.',
    step_4: 'Klicken Sie in der Seitenleiste auf den Tab „Channel connection“ und tragen Sie folgende Angaben ein:',
    step_5: 'Speichern Sie die Änderungen über die Schaltfläche „Save“ oben rechts.',
    step_6:
      'Klicken Sie nach dem Speichern oben rechts auf das „More“-Symbol, dann auf „Register“ und anschließend auf „Activate“.',
    step_7:
      'Wechseln Sie zurück zum Tab „General“, setzen Sie den „Integration status“ auf „Active“ und speichern Sie die Änderungen.',
    outro: 'Danach können Sie das Menü aus Deliverect übertragen und eine Testbestellung anlegen.',
  },
  connected: {
    title: 'Deliverect ist verbunden',
    description: 'Diese Integration ist eingerichtet.',
  },
};
